/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-10-24, 11:29:27
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-22, 13:16:12
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'PanelHeader',

  props: ['brandLogos'],

  methods: {
    goto(pathObject) {
      const { name, params } = pathObject;
      this.$router.push({ name, params });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Panel/PanelHeader/component.js